import {
  buildAcademicGradeEntryProgress,
  deriveAcademicGradeEntryStudentStatus,
  formatAcademicCompositeGrade,
  type AcademicBaseGrade,
  type AcademicGradeEntryWorkspace,
  type AcademicGradeModifier,
} from '@triedge/academics-domain';

const createStudent = (
  studentKey: string,
  name: string,
  baseGrade: AcademicBaseGrade | null,
  modifier: AcademicGradeModifier,
  comment: string | null,
  history: AcademicGradeEntryWorkspace['students'][number]['history'],
) => ({
  studentKey,
  studentId: studentKey.replace('student-', 'stu-'),
  name,
  baseGrade,
  modifier,
  grade: formatAcademicCompositeGrade(baseGrade, modifier),
  comment,
  hasComment: Boolean(comment?.trim()),
  status: deriveAcademicGradeEntryStudentStatus({ baseGrade }),
  history,
});

const students = [
  createStudent(
    'student-levine',
    'Ari Levine',
    'A',
    'none',
    'Strong grasp of text evidence and paragraph structure.',
    [
      {
        id: 'history-levine-q2',
        kind: 'previous-period',
        label: 'Quarter 2',
        grade: 'A-',
        note: 'Steady improvement after the midterm writing conference.',
        tone: 'positive',
      },
    ],
  ),
  createStudent(
    'student-katz',
    'Miriam Katz',
    'C',
    '+',
    '',
    [
      {
        id: 'history-katz-q2',
        kind: 'latest-note',
        label: 'Teacher note',
        grade: null,
        note: 'Needs one more intervention note before report-card lock.',
        tone: 'warning',
      },
    ],
  ),
  createStudent(
    'student-rubin',
    'Noah Rubin',
    null,
    'none',
    null,
    [],
  ),
] as const;

export const mockAcademicsWorkspace: AcademicGradeEntryWorkspace = {
  gradebookId: 'gradebook-ela-5a-q3',
  sectionKey: 'ela-5a',
  markingPeriodKey: 'q3',
  subjectTitle: 'Language Arts',
  classLabel: 'Grade 5A',
  teacherName: 'Mrs. Feldman',
  academicYear: '2025-2026',
  periodLabel: 'Quarter 3',
  workflowState: 'draft',
  submittedAt: null,
  updatedAt: '2026-04-20T09:00:00.000Z',
  progress: buildAcademicGradeEntryProgress(students),
  students: [...students],
};
